import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { createReduxHistoryContext } from 'redux-first-history';
import { isStrictFeatureEnabled } from '../../common/utils/featureFlagUtils.js';
import { configureStoreWithMiddleware } from '../../selfservice/common/store.js';
import { createFakeHistory } from '../common/fakeHistory.js';
import { createSiteRoutes } from '../site/SitePath.js';
import { siteRoutes as siteRoutesCoCo } from '../site/SitePathCoCo.js';
import { getFeatureFlags } from '../site/configStore.js';
import { ExposedFunctions } from '../site/exposedFunctions.js';
import { siteEpic } from '../site/siteEpic.js';
import type { State } from '../../selfservice/common/store.js';
import type { IHistoryContext } from 'redux-first-history';

export interface BrowserAppProps {
  callback: () => void;
  initialState: State;
}

export const BrowserApp = ({ initialState, callback }: BrowserAppProps) => {
  callback();
  const cocoEnabled = isStrictFeatureEnabled(getFeatureFlags().coco);
  const routes = cocoEnabled ? siteRoutesCoCo : createSiteRoutes();
  const router = createBrowserRouter(routes);
  const iHistoryContext: IHistoryContext = createReduxHistoryContext({ history: createFakeHistory(router) });
  const { epicMiddleware, store } = configureStoreWithMiddleware(iHistoryContext, initialState);
  // It's important to run epicMiddleware before history so initial LOCATION_CHANGE event gets registered by Epic
  epicMiddleware.run(siteEpic);
  iHistoryContext.createReduxHistory(store);

  return (
    <Provider store={store}>
      <ExposedFunctions store={store} />
      <RouterProvider router={router} />
    </Provider>
  );
};
